<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'app'
};
</script>

<style lang="scss">
  // CoreUI Icons Set
  @import '~@coreui/icons/css/coreui-icons.min.css';
  /* Import Simple Line Icons Set */
  $simple-line-font-path: '~simple-line-icons/fonts/';
  @import '~simple-line-icons/scss/simple-line-icons.scss';
  /* Import Flag Icons Set */
  // @import '~flag-icon-css/css/flag-icon.min.css';
  /* Import Bootstrap Vue Styles */
  @import '~bootstrap-vue/dist/bootstrap-vue.css';
  @import '~vue-json-pretty/lib/styles.css';
  /* Import vue-datetime css */
  @import '~vue-datetime/dist/vue-datetime.css';
  // Import Main styles for this application
  @import 'assets/scss/style';
</style>
